import Space from "components/common/space";
import React from "react";
import T from "@marginly/ui/components/typography";
import { formatNum } from "util/format";
import { REFER_BADGES_CAMELOT } from "components/leaderboard/hooks/use-rating";
import ReferralLink from "../../../referral-link/referral-link";
import * as S from "./styled";
import { createReferralUrl } from "util/common";
import { useRx } from "contexts/rx";
import copy from "copy-to-clipboard";
import { ShowMoreButton } from "components/leaderboard/styled";
interface Props {
  refCode: string | null | undefined;
  onShowMoreButtonClick?: () => void;
}

export function ReferSection({ refCode, onShowMoreButtonClick }: Props) {
  const { notification$ } = useRx();

  const handleCopy = (refCode: string) => {
    copy(createReferralUrl(refCode));
    notification$.next({ message: "Invitation link copied." });
  };

  return (
    <S.ReferBock>
      <div>
        <div className="title">
          <T className="headerL" as={"h2"}>
            Refer friends and earn
          </T>
          <Space height={12} heightMobile={6} />
          <T body secondary>
            Only traders who are in the top 50 of the leaderboard count
            towards&nbsp;the referral&nbsp;competition.
          </T>
        </div>
        <Space height={24} heightMobile={24} />
        {refCode && (
          <div className="copylink">
            <ReferralLink
              referralCode={refCode}
              handleCopy={() => handleCopy(refCode)}
              className="full-width referral-link"
            />
            <Space height={24} heightMobile={20} />
          </div>
        )}
      </div>

      <S.RankingBlock $withButton={Boolean(onShowMoreButtonClick)}>
        <S.RankingTops>
          {REFER_BADGES_CAMELOT.map(({ position, prize, src }) => {
            return (
              <S.RankingUnit key={position}>
                <img
                  src={`/contest/images/referral/thumbnail-${src}.png`}
                  alt=""
                  className="coin"
                />
                <Space height={6} heightMobile={6} />
                <T caption secondary>
                  #{position}
                </T>
                <T body>${formatNum(prize)}</T>
              </S.RankingUnit>
            );
          })}
        </S.RankingTops>
        {onShowMoreButtonClick && (
          <>
            <Space height={48} heightMobile={32} />
            <ShowMoreButton onClick={onShowMoreButtonClick}>
              Referrer Ranking
            </ShowMoreButton>
          </>
        )}
      </S.RankingBlock>
    </S.ReferBock>
  );
}
